export default __webpack_public_path__ + "static/media/software-gestion-gestion-hotelera.5afcdc40.png";